import React, {useEffect, useState} from "react";
import styles from "../assets/css/footer.module.scss";
import {Collapse, Container, Grid, Typography} from "@mui/material";
import {NeshanMap as Map} from "./NeshanMap";
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

const NeshanMap = React.memo(Map);
const Footer = (props) => {
    const [r1, setR1] = useState(null);
    const [r2, setR2] = useState(null);
    const [marker, setMarker] = useState(null);
    const [position, setPosition] = useState([35.6997362112193, 51.337618205943]);
    const setLocation = (index) => {
        r2.flyTo([props.places[index].lat, props.places[index].lng], 17)

        marker.setLatLng([props.places[index].lat, props.places[index].lng])
    }

    useEffect(() => {
        if (props.places.length > 0) {
            r2.flyTo([props.places[0].lat, props.places[0].lng], 17)
            let marker = r1.marker([props.places[0].lat, props.places[0].lng])
                .addTo(r2);
            setMarker(marker);
        }

    }, [props.places]);
    return <div className={styles.container}>
        <Container maxWidth={"lg"}>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <div className={styles.informationContainer}>
                        {props.places.map((item, index) => <Item {...item} index={index} setLocation={setLocation} key={index}/>)}

                        <div style={{color: "#fff"}}>
                            <EmailRoundedIcon/>
                            <Typography variant={"body1"} component={"p"}>
                                {props.mail}
                            </Typography>

                        </div>
                    </div>

                </Grid>
                <Grid item xs={12} md={6}>
                    <NeshanMap
                        style={{
                            width: "100%", height: "450px", margin: 0, padding: 0, background: "#eee",
                        }}
                        options={{
                            key: 'web.Qcm8Zwe5LAZbpH8cv9wwYJDBRY0Kv6J1fkaJihgZ',
                            center: position,
                            zoom: 16,
                            maptype: 'standard-night',
                            zoomControl: true,
                            search: true,
                            serviceKey: "service.An7lQ4gLCirxxggUdU2U7Cxhv1YCgsOc9BNsiHWj",

                        }}

                        onInit={(L, myMap) => {
                            setR1(L);
                            setR2(myMap);
                            // let marker = L.marker(position, {draggable: 'true'})
                            //     .addTo(myMap);
                            // .bindPopup(props.title);

                            // myMap.on('click', function (e) {
                            //     marker.setLatLng(e.latlng);
                            //     setPos({lat: e.latlng.lat, lng: e.latlng.lng});
                            //
                            //
                            // });
                            // marker.on('dragend', function (event) {
                            //     let marker = event.target;
                            //     let p = marker.getLatLng();
                            //     // marker.setLatLng({lat: p.lat, lng: p.lng});
                            //
                            //
                            // });
                        }}

                    />
                </Grid>

            </Grid>
        </Container>
    </div>;
};

export default Footer;

const Item = (props) => {
    const [open, setOpen] = useState(false);
    const toggle = () => {
        setOpen(prevState => !prevState);
        if (!open) {
            props.setLocation(props.index);
        } else props.setLocation(0);
    }
    return <>
        <div style={{color: "#fff"}} onClick={e => {
            toggle();
        }}>
            <LocationOnRoundedIcon/>
            <Typography variant={"body1"} component={"p"}>
                {props.address}
            </Typography>
        </div>
        <Collapse in={open}>
            <div style={{color: "#fff", display: "flex", flexDirection: "row"}}>
                <LocalPhoneRoundedIcon/>
                <Typography variant={"body1"} component={"p"}>
                    {props.phone}
                </Typography>
            </div>
        </Collapse>
    </>
}